import { render, staticRenderFns } from "./create-certificate-popups.vue?vue&type=template&id=9c01d47c"
import script from "./create-certificate-popups.vue?vue&type=script&lang=js"
export * from "./create-certificate-popups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports